<template>
  <v-chip
    :small="!xSmall"
    :x-small="xSmall"
    label
    class="ht-status-chip"
    :class="`ht-status-chip--${tone}`"
    :color="unknownColor ? color : undefined"
    :outlined="unknownColor"
  >
    <v-icon left x-small>{{ resolvedIcon }}</v-icon>
    <slot>{{ label }}</slot>
  </v-chip>
</template>

<script>
// Soft status badge. Always shows an icon next to the text so state is not
// conveyed by color alone. `color` accepts the Vuetify color names pages already use
// (e.g. "success", "red darken-1", "orange"). Presentation only.
const TONES = {
  success: ["success", "green", "teal"],
  error: ["error", "red", "pink"],
  warning: ["warning", "orange", "amber", "yellow", "deep-orange"],
  info: ["info", "blue", "primary", "indigo", "cyan", "light-blue"],
};

const ICONS = {
  success: "mdi-check-circle",
  error: "mdi-close-circle",
  warning: "mdi-alert-circle",
  info: "mdi-information",
  neutral: "mdi-circle-medium",
};

export default {
  name: "StatusChip",
  props: {
    label: { type: String, default: "" },
    color: { type: String, default: "" },
    icon: { type: String, default: "" },
    xSmall: { type: Boolean, default: false },
  },
  computed: {
    tone() {
      const base = String(this.color || "").trim().split(" ")[0];
      const hit = Object.keys(TONES).find((t) => TONES[t].includes(base));
      return hit || "neutral";
    },
    // Colors outside the known tones keep their identity as an outlined chip
    unknownColor() {
      return this.tone === "neutral" && !!this.color;
    },
    resolvedIcon() {
      return this.icon || ICONS[this.tone];
    },
  },
};
</script>

<style scoped>
.ht-status-chip {
  font-weight: 600;
  letter-spacing: 0.01em;
}

.ht-status-chip--success {
  background-color: #e3f3e6 !important;
  color: #1f6a24 !important;
}

.ht-status-chip--error {
  background-color: #fde8e8 !important;
  color: #b42323 !important;
}

.ht-status-chip--warning {
  background-color: #fff1d9 !important;
  color: #9a5b00 !important;
}

.ht-status-chip--info {
  background-color: #e3f0fd !important;
  color: #11569b !important;
}

.ht-status-chip--neutral:not(.v-chip--outlined) {
  background-color: #edf1f4 !important;
  color: #455a68 !important;
}

.ht-status-chip .v-icon {
  color: inherit !important;
}
</style>
